<template>
  <div class="main-conatiner">
    <div class="content-header">
      <div v-for="item in menus" :key="item.key" class="mb30">
        <span @click="goLink(item.route)">{{item.title}} {{item.route}}</span>
      </div>
      <div>state:{{state}}</div>
    </div>
    <section class="content-wrapper">
      <!-- 主应用渲染区，用于挂载主应用路由触发的组件 -->
      <router-view v-show="currentRoute == 'Home'" />

      <!-- 子应用渲染区，用于挂载子应用节点 -->
      <section v-show="currentRoute != 'Home'" id="frame"></section>
    </section>
  </div>
</template>

<script setup>
import {ref, computed, onMounted} from "vue";
import { useRouter, useRoute } from "vue-router";
import store from '@/store'

const state = store.getGlobalState();
const router = useRouter();
const route = useRoute();
const menus = ref([
  {
    key: "Home",
    title: "主页",
    route: "/home"
  },
  {
    key: "sub-team",
    title: "Team 主页",
    route: "/sub-team/home/index"
  },
  {
    key: "main-report",
    title: "主项目 Report 主页",
    route: "/main-report"
  },
  {
    key: "sub-report",
    title: "Report 子项目",
    route: "/sub-report/home/index"
  },
]);

const currentRoute = computed(() => {
  return (route.path === '/home' || route.path === '/userinfo' || route.path === '/main-report') ? 'Home' : "other";
});

const goLink = (link) => {
  router.push(link);
}
</script>

<style lang="scss" scoped>
.main-conatiner, #frame {
  height: 100%;
  width: 100%;
  position: relative;
  color: #2c3e50;
  .content-header{
    position: fixed;
    box-sizing: border-box;
    padding: 12px;
    width: 200px;
    height: 100%;
    bottom: 0;
    left: 0;
    word-break: break-all;
    overflow-x: hidden;
    overflow-y: auto;
  }
  .content-wrapper{
    height: 100%;
    width: calc(100% - 200px);
    margin-left: 200px;
    background: #881f9f;
    overflow: auto;
  }
}
</style>
